import consultation from './consultation.vue'

export default consultation
